import actions from "./actions";

const betriebsanweisungTemplateModule = {
  actions,
};

export default betriebsanweisungTemplateModule;
